// NOTE ON CACHING / MULTI-SCHOOL SAFETY:
// This app is built separately for EACH school (see school-crm-api's
// SchoolService::$ENV_FILE), with VUE_APP_SCHOOL_TYPE and
// VUE_APP_SCHOOL_PARTICIPANT_TERM baked into the compiled bundle at build
// time from that specific school's own .env file. Each school is deployed
// on its own separate domain, so there is no runtime lookup (no
// localStorage/cookie read) that could let one school's "Camper"/"Student"
// (or any custom participant term) leak into another school's site. No
// js-cookie/VueCookies `domain` option is configured anywhere in this app
// either, so cookies are never shared across domains/subdomains. A user who
// visits multiple school sites in the same browser will always see the
// correct terminology for whichever site they're currently on, with no
// stale/mixed-up wording from a previously visited school.
import pluralize from 'pluralize'

const schoolType = process.env.VUE_APP_SCHOOL_TYPE
const schoolParticipantTerm = process.env.VUE_APP_SCHOOL_PARTICIPANT_TERM

export const instanceSessionCamperNames = {
  computed: {
    sessionSemester() {
      return schoolType == 1 ? 'Semester' : 'Session'
    },
  },
  methods: {
    camperStudent(form = 'singular') {
      const word = schoolParticipantTerm || ''
      switch (form) {
        case 'singular':
          return word
        case 'plural':
          return pluralize(word)
        case 'possessiveSingular':
          return `${word}'s`
        case 'possessivePlural':
          return `${pluralize(word)}'s`
        default:
          return word
      }
    },
  }
}

export const _ = null
